import ThemifyIcon from "./ThemifyIcon.vue";

export default ThemifyIcon;



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-themify-icons@1.0.0_@vue+compiler-sfc@3.5.38_babel-core@6.26.3_supports-color@5.5.0_06021271dd4521d78cde5ad2e90bc0ad/~/vue-themify-icons/index.js
// module id = vciC
// module chunks = 5